import {
  GroupChat,
  CreateGroupChatInput,
  UpdateGroupChatInput,
} from "@/types/groupChat";
import { client } from "@/api/client";
import axios, { AxiosInstance } from "axios";
import { authHeaders } from "@/hoc/authHeaders";

export async function fetchGroupChats(url: string): Promise<GroupChat[]> {
  const headers = await authHeaders();
  const { data } = await client
    .get(url, {
      headers,
    })
    .catch((error) => {
      throw new Error(error.response.message);
    });
  return data;
}

export async function fetchGroupChat(url: string): Promise<GroupChat> {
  const headers = await authHeaders();
  const { data } = await client
    .get(url, {
      headers,
    })
    .catch((error) => {
      throw new Error(error.response.message);
    });
  return data;
}

export interface GroupChatRepository {
  createGroupChat(group_chat: CreateGroupChatInput): Promise<GroupChat>;
  updateGroupChat(
    id: string | string[],
    group_chat: UpdateGroupChatInput
  ): Promise<GroupChat>;
}

class GroupChatRepositoryImpl implements GroupChatRepository {
  private readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async createGroupChat(group_chat: CreateGroupChatInput): Promise<GroupChat> {
    const headers = await authHeaders();
    const { data } = await this.client
      .post(
        `/api/v1/group_chats`,
        {
          group_chat: {
            title: group_chat.title,
          },
          user_ids: group_chat.user_ids,
        },
        {
          headers,
        }
      )
      .catch((error) => {
        throw error.response.status;
      });

    return data;
  }

  async updateGroupChat(
    id: string | string[],
    group_chat: UpdateGroupChatInput
  ): Promise<GroupChat> {
    const headers = await authHeaders();
    const { data } = await this.client
      .put(
        `/api/v1/group_chats/${id}`,
        {
          group_chat,
        },
        {
          headers,
        }
      )
      .catch((error) => {
        throw error.response.status;
      });
    return data;
  }
}

export function newGroupChatRepository(
  client: AxiosInstance
): GroupChatRepository {
  return new GroupChatRepositoryImpl(client);
}
